<div class="alert" [ngClass]="getClassOf(this.alertService.nivelAlerta)" role="alert" *ngIf="this.alertService.nivelAlerta">
    {{this.alertService.mensaje}}
</div>

  